"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationAutoCompleteInput = LocationAutoCompleteInput;
exports.LocationAutoCompleteInputRenderer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactDependentScript = _interopRequireDefault(require("react-dependent-script"));
var _reactPlacesAutocomplete = _interopRequireDefault(require("react-places-autocomplete"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactstrap = require("reactstrap");
function LocationAutoCompleteInput(_ref) {
  var googleApiKey = _ref.googleApiKey,
    onChange = _ref.onChange,
    value = _ref.value;
  return _react["default"].createElement(_reactDependentScript["default"], {
    loadingComponent: _react["default"].createElement("div", null, "..."),
    scripts: ["https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKey, "&libraries=places")]
  }, _react["default"].createElement(_reactPlacesAutocomplete["default"], {
    value: value,
    onChange: onChange
  }, LocationAutoCompleteInputRenderer));
}
var LocationAutoCompleteInputRenderer = exports.LocationAutoCompleteInputRenderer = function LocationAutoCompleteInputRenderer(_ref2) {
  var getInputProps = _ref2.getInputProps,
    suggestions = _ref2.suggestions,
    getSuggestionItemProps = _ref2.getSuggestionItemProps,
    loading = _ref2.loading;
  return _react["default"].createElement("div", null, _react["default"].createElement(_reactstrap.Input, getInputProps({
    placeholder: 'Search Places...'
  })), _react["default"].createElement("div", null, loading && _react["default"].createElement("div", null, "Loading..."), suggestions.map(function (suggestion, indx) {
    var style = suggestion.active ? {
      backgroundColor: '#fafafa',
      cursor: 'pointer'
    } : {
      backgroundColor: '#ffffff',
      cursor: 'pointer'
    };
    return _react["default"].createElement("div", (0, _extends2["default"])({
      key: "suggestion-".concat(indx)
    }, getSuggestionItemProps(suggestion, {
      style: style
    })), _react["default"].createElement("span", null, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faMapMarkerAlt
    }), " ", suggestion.description));
  })));
};